export const WarningIcon = ({ className }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_2397_52407)">
        <path
          d="M11.1266 3.14219L17.9594 15.007C18.4383 15.843 17.8196 16.875 16.8336 16.875H3.168C2.18206 16.875 1.56331 15.843 2.04222 15.007L8.87503 3.14219C9.36722 2.28594 10.6344 2.28594 11.1266 3.14219Z"
          stroke="#282828"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 11.25V8.125"
          stroke="#282828"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 15C10.5178 15 10.9375 14.5803 10.9375 14.0625C10.9375 13.5447 10.5178 13.125 10 13.125C9.48223 13.125 9.0625 13.5447 9.0625 14.0625C9.0625 14.5803 9.48223 15 10 15Z"
          fill="#282828"
        />
      </g>
      <defs>
        <clipPath id="clip0_2397_52407">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
